import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Markdown from "react-markdown";
import t from "../locales";
import Button from "../components/button";
import Dialog from "../components/dialog";
import heroLarge from "../assets/images/intro_img_big.png";

export default function Intro() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenDialog = () => setDialogOpen(true);

  const handleCloseDialog = () => setDialogOpen(false);

  const handleDialogSubmit = (groupCode) => {
    setDialogOpen(false);
    const queryValue = groupCode?.trim();
    const searchParams = new URLSearchParams();

    if (queryValue) {
      searchParams.set("classCode", queryValue);
    }

    navigate({
      pathname: "/survey",
      search: searchParams.toString(),
    });
  };

  return (
    <>
      <title>{t("intro.title")}</title>
      <img className="intro__image --show-lg" src={heroLarge} alt="" />
      <div className="intro">
        <h1 className="intro__title">{t("intro.heading")}</h1>
        <img className="intro__image --hide-lg" src={heroLarge} alt="" />
        <Markdown>{t("intro.paragraph")}</Markdown>
        <Button label={t("intro.button")} onClick={handleOpenDialog} />
      </div>
      <Dialog
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onSubmit={handleDialogSubmit}
        title={t("intro.dialog.title")}
        description={t("intro.dialog.description")}
        inputPlaceholder={t("intro.dialog.input.placeholder")}
        submitLabel={t("intro.dialog.submit")}
      />
    </>
  );
}
